import axios, { HttpStatusCode } from 'axios'
import { useEffect, useRef } from 'react'
import { userDataQuery } from 'src/editor/api/queries/user-data-query'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

export const useApplyUserLocale = () => {
  const { i18n } = useTypedTranslation()
  const lastApplied = useRef<string | null>(null)
  const { data: user, isFetched: isUserFetched } = userDataQuery.useQuery({
    validationOptions: {
      handleError: error => {
        if (
          axios.isAxiosError(error) &&
          error.response?.status === HttpStatusCode.Unauthorized
        ) {
          const redirect =
            error.response.data?.location || error.response.data?.redirect
          if (redirect) {
            window.location.href = redirect
          }
        }
      },
    },
  })
  const userLocale = user?.dashboardLocale ?? null

  useEffect(() => {
    let isCancelled = false

    if (!userLocale) {
      return
    }

    ;(async () => {
      if (i18n.language === userLocale || lastApplied.current === userLocale) {
        if (!isCancelled) {
          lastApplied.current = userLocale
        }
        return
      }

      await i18n.changeLanguage(userLocale)
      if (isCancelled) {
        return
      }
      lastApplied.current = userLocale
    })()

    return () => {
      isCancelled = true
    }
  }, [i18n, userLocale])

  return { isUserFetched, user }
}
